import React from "react"
import { useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import CustomModal from "../basics/interface/CustomModal"
import { COLORS } from "../../utilities/Constants"

// Version V2 (CustomModal) de AtelierCloreModal — confirme que tout a été payé
// puis clôt la fiche. La sauvegarde (etat = CLOS, paid = true) est déléguée à
// AtelierV2 via `onConfirm` : elle part du form (transactions datées) et met à
// jour l'UI. Props : onConfirm (→ Promise), onClose.
const AtelierCloreModalV2 = ({ onConfirm, onClose }) => {
	const post = useSelector((state) => state.atelierInfo.postAtelier)

	const cloreAtelier = () => {
		// Ne fermer qu'en cas de succès : en erreur (ex. clôture bloquée par un
		// débit de stock incomplet — 400 + rollback), le modal reste ouvert et
		// affiche le message du back. Avant, il se fermait en silence et rien
		// n'indiquait que la fiche n'était PAS close.
		onConfirm().then((res) => {
			if (res && res.atelier) onClose()
		})
	}

	const saving = post.saving
	const error = post.error

	if (error) {
		return (
			<CustomModal
				title={"Clôture impossible"}
				onClose={onClose}
				buttons={[
					{
						title: "Fermer",
						styleName: "primary",
						onClick: onClose,
					},
				]}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: 10,
						textAlign: "center",
						padding: "8px 0",
					}}
				>
					<FontAwesomeIcon
						icon={faTimesCircle}
						size="2x"
						style={{ color: COLORS.danger }}
					/>
					<div style={{ fontSize: 13 }}>
						{error.message ||
							error.msg ||
							"La clôture a échoué. La fiche n'a pas été close."}
					</div>
				</div>
			</CustomModal>
		)
	}

	return (
		<CustomModal
			title={"Êtes-vous sûr que tout a été payé ?"}
			subtitle={"La fiche sera clôturée et marquée comme payée."}
			onClose={onClose}
			showCloseButton={!saving}
			buttons={
				saving
					? []
					: [
							{ title: "Annuler", styleName: "secondary", onClick: onClose },
							{ title: "Oui, clôturer", styleName: "primary", onClick: cloreAtelier },
						]
			}
			showFooter={!saving}
		>
			{saving && (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						padding: "12px 0",
					}}
				>
					<FontAwesomeIcon icon={faSync} size="2x" spin />
				</div>
			)}
		</CustomModal>
	)
}

export default AtelierCloreModalV2
